'use client';

import React, { useState, useEffect } from 'react';
import { trackEnterpriseGovernmentView, trackGovernmentTenderInteraction } from '@/lib/analytics';
import HeroSection from './HeroSection';
import SolutionOverview from './SolutionOverview';
import CarbonCreditsVideo from './CarbonCreditsVideo';
import DataCenterESGSection from './DataCenterESGSection';
import UtilitiesSection from './UtilitiesSection';
import PortSustainability from './PortSustainability';
import EcosystemRestoration from './EcosystemRestoration';
import RailwaySustainability from './RailwaySustainability';
import GovernmentEngagement from './GovernmentEngagement';
import BRSRLiteSection from './BRSRLiteSection';
import CaseStudyLibrary from './CaseStudyLibrary';
import ConsultationBooking from './ConsultationBooking';
import Footer from '@/app/homepage/components/Footer';
import LanguageSelector from '@/app/homepage/components/LanguageSelector';
import WhatsAppButton from '@/app/homepage/components/WhatsAppButton';

export default function EnterpriseGovernmentInteractive() {
  useEffect(() => {
    // Track page view for government tender visibility
    trackEnterpriseGovernmentView('page_load');
    trackGovernmentTenderInteraction('page_view', '/enterprise-government-solutions');
  }, []);

  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [selectedSector, setSelectedSector] = useState<string | null>(null);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('gencarbon_language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (language: string) => {
    setCurrentLanguage(language);
    localStorage.setItem('gencarbon_language', language);
  };

  return (
    <>
      {/* Language Selector - Fixed Position */}
      <div className="fixed top-20 right-4 z-40">
        <LanguageSelector
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Main Content */}
      <HeroSection currentLanguage={currentLanguage} />
      <SolutionOverview 
        currentLanguage={currentLanguage}
        onSectorSelect={setSelectedSector}
      />
      <CarbonCreditsVideo currentLanguage={currentLanguage} />
      <DataCenterESGSection currentLanguage={currentLanguage} />
      <UtilitiesSection currentLanguage={currentLanguage} />
      <PortSustainability currentLanguage={currentLanguage} />
      <EcosystemRestoration currentLanguage={currentLanguage} />
      <RailwaySustainability currentLanguage={currentLanguage} />
      <GovernmentEngagement currentLanguage={currentLanguage} />
      <BRSRLiteSection currentLanguage={currentLanguage} />
      <CaseStudyLibrary 
        currentLanguage={currentLanguage}
        selectedSector={selectedSector}
      />
      <ConsultationBooking currentLanguage={currentLanguage} />
      <Footer currentLanguage={currentLanguage} />

      {/* WhatsApp Floating Button */}
      <WhatsAppButton currentLanguage={currentLanguage} />
    </>
  );
}